module.exports = __webpack_public_path__ + "img/DTIO3.2efb3b4a.png";